import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="text-lg font-heading font-bold text-foreground-50 whitespace-nowrap">
                  {t('siteName')}
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed max-w-md">
                {t('siteDescription')}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-foreground-50 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors">
                    {t('nav.home')}
                  </Link>
                </li>
                <li>
                  <Link to="/category/guochan" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors">
                    {t('nav.categories')}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors">
                    {t('nav.about')}
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-foreground-50 mb-4">
                热门分类
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/category/guochan" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors">
                    国产剧
                  </Link>
                </li>
                <li>
                  <Link to="/category/hanju" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors">
                    韩剧
                  </Link>
                </li>
                <li>
                  <Link to="/category/meiju" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors">
                    美剧
                  </Link>
                </li>
                <li>
                  <Link to="/category/dongman" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors">
                    动漫
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-700/20">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                {t('footer.copyright')}
              </p>
              <div className="flex items-center gap-6">
                <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
                  {t('footer.about')}
                </Link>
                <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
                  {t('footer.privacy')}
                </a>
                <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
                  {t('footer.terms')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}